import { Injectable } from '@angular/core';
import { BullhornActionConfigurations } from './bullhorn-action-configurations';
import { ITriggerConfigService } from './itriggerconfig.service';
import { ITriggerConfig } from './shared-action-configurations';

@Injectable({
  providedIn: 'root',
})
export class BullhornTriggerConfigService implements ITriggerConfigService {
  getConfigs(): ITriggerConfig[] {
    return BullhornActionConfigurations.triggerConfigs;
  }
}
